import { render, staticRenderFns } from "./H5Tabbar.vue?vue&type=template&id=b470d4ba&scoped=true"
import script from "./H5Tabbar.vue?vue&type=script&lang=js"
export * from "./H5Tabbar.vue?vue&type=script&lang=js"
import style0 from "./H5Tabbar.vue?vue&type=style&index=0&id=b470d4ba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b470d4ba",
  null
  
)

export default component.exports